<template lang="pug">
.v-field.field(v-if="field" :class="[field.error ? 'error' : '', theme ? 'field--' + theme : '']")
	template(v-if="field.type === 'select'")
		v-field-select(:field="field" :model-value="localValue" @update:model-value="handlerInput")
	template(v-else-if="field.type === 'currency'")
		v-field-currency(:field="field" :model-value="localValue" @update:model-value="handlerInput")
	template(v-else-if="field.type === 'tabs'")
		v-field-tabs(:field="field" :model-value="localValue" @update:model-value="handlerInput")
	template(v-else-if="field.type === 'question'")
		v-field-question(:field="field" :model-value="localValue" @update:model-value="handlerInput")
	template(v-else-if="field.type === 'checkbox'")
		v-field-checkbox(:field="field" :model-value="localValue" @update:model-value="handlerInput" :disabled="field.disabled")
	template(v-else-if="field.type === 'check-list'")
		v-field-check-list(:field="field" :model-value="localValue" @update:model-value="handlerInput")
	template(v-else-if="field.type === 'file'")
		v-field-file(:field="field" @fileinput="fileInput" @fileremove="fileRemove")
	template(v-else-if="field.type === 'range'")
		v-field-range(:field="field" :model-value="localValue" @update:model-value="handlerInput")
	template(v-else)
		v-field-text(:field="field" :model-value="localValue" :disabled="field.disabled" @update:model-value="handlerInput" @update-inner-field="handlerUpdateInnerField" @focus="field.error = null")

	.field__error(v-if="field.error" v-html="field.error")
</template>

<script>
export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Object, String, Number, Boolean, Date],
			default: null
		},

		theme: {
			type: String,
			default: null
		}
	},

	emits: [
		'fileinput',
		'fileremove',
		'update:model-value',
		'update-inner-field'
	],

	data() {
		return {
			localValue: null
		};
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				this.updateLocalValue();
			}
		}
	},

	methods: {

		fileInput(e) {
			this.$emit('fileinput', e);
		},

		fileRemove(e) {
			this.$emit('fileremove', e);
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handlerInput(value, field) {
			this.$emit('update:model-value', value, field);

			if (field?.error) {
				field.error = null;
			}
		},

		handlerUpdateInnerField(...options) {
			this.$emit('update-inner-field', ...options);
		}
	}
};
</script>
